<template>
  <article class="tile is-child box detail-page-tile">
    <!-- <div class="is-flex"
      style="justify-content: space-between">
      <span class="icon is-small tooltip is-tooltip-right is-clickable mr-2"
        data-tooltip="maximize">
        <i class="mdi mdi-24px"
          :class="{ 'mdi-arrow-collapse-left' : !editMaximize, 'mdi-arrow-collapse-right' : editMaximize}"
          @click="toggleEditMaximize()" />
      </span>
    </div> -->
    <div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Template</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control is-expanded">
              <multiselect v-model="selectedTemplate"
                track-by="message"
                label="message"
                placeholder="Select Template"
                :options="templates"
                :loading="isTemplateLoading"
                :searchable="true"
                :allow-empty="true"
                :options-limit="templateFilter.pageSize"
                :disabled="$licenceExpired"
                @select="selectTemplate" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr>

    <quote-email-modal :emailer.sync="emailer"
      :quote-ids="quoteIds"
      :enable-attach="enableAttach"
      :reply-to-message-id="innerReplyToEmail.replyToMessageId"
      :reply-to-sender-emails="replyToSenderEmails"
      :reply-to-email-ccs="replyToEmailCcs"
      :reply-to-email-bccs="replyToEmailBccs"
      :email-subject="innerReplyToEmailSubject"
      :email-message="innerReplyToEmailMessage"
      @resetEmail="resetEmail"
      @new-email="newEmailInput"
      @sent="sent"
      @discard="discardEmail">
      <template slot="template-actions">
        <button class="button is-primary tooltip"
          :data-tooltip="$licenceExpired ? 'Disabled, as your licence has expired' : 'Edit message template'"
          :disabled="$licenceExpired"
          @click="isEmailTemplateModalActive = true">
          <span class="icon">
            <i class="mdi mdi-pencil mdi-20px" />
          </span>
          <span>Edit Template</span>
        </button>
      </template>
    </quote-email-modal>
    <quote-communication-email-modal :active.sync="isAttachmentModalActive"
      v-model="selectedImages"
      :show-icon="true"
      :attach-disabled="false"
      :cancel-disabled="false"
      :emailer="emailer"
      :selected-attachment-email-id="selectedAttachmentEmailId"
      :is-incoming="isIncoming"
      @ok="closeAttachModal()"
      @cancel="closeAttachModal()"
      @close="closeAttachModal()">
      <p slot="text-title">Attachment</p>
    </quote-communication-email-modal>
    <vue-email-template-modal v-if="isEmailTemplateModalActive"
      :active.sync="isEmailTemplateModalActive"
      @close="closeTemplateModal" />

  </article>
</template>

<script>
import { Emailer } from '@/classes'
import StoreUtil from '@/store/utils'
import _cloneDeep from 'lodash/cloneDeep'
import QuoteCommunicationsMixin from '../mixins/QuoteCommunicationsMixin'
import { RemarkTypes, AssetTypes, EmailAssetTypes } from '@/enums'
import VueEmailTemplateModal from '@/components/VueEmail/VueEmailTemplateModal'
import { EmailService } from '@/services'
import Multiselect from 'vue-multiselect'
import QuoteEmailModal from './QuoteEmailModal.vue'
import QuoteCommunicationEmailModal from './QuoteCommunicationEmailModal.vue'
import { mapGetters } from 'vuex'

// Temporary const for copyright message
const divider = '=============================================================='
const copyright =
  'All accompanying materials are the exclusive property of [COMPANY].  All [COMPANY] rights are reserved.  These Materials must not be reproduced, adapted, modified, published, or communicated to any person in any form, without express prior written consent of [COMPANY].  Any unauthorised use of these Materials will be vigorously pursued and may result in legal action, including a claim for damages or an account for loss of profits.'

export default {
  name: 'QuoteEmail',
  components: { QuoteEmailModal, QuoteCommunicationEmailModal, VueEmailTemplateModal, Multiselect },
  mixins: [QuoteCommunicationsMixin],
  props: {
    quote: {
      type: Object,
      required: true
    },
    enableAttach: {
      type: Boolean,
      default: true
    },
    enableSend: {
      type: Boolean,
      default: false
    },
    toggleAttachButton: {
      type: Boolean,
      default: false
    },
    replyToEmail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    selectedAttachmentEmailId: {
      type: String,
      default: ''
    },
    isIncoming: {
      type: Boolean,
      default: false
    },
    msgDetails: {
      type: Object,
      default: () => {
        return {
          quoteId: null,
          customer: null,
          rego: null,
          jobStart: null,
          jobEnd: null,
          excess: null,
          mobile: null,
          message: '',
          shopName: ''
        }
      }
    }
  },
  data: () => {
    return {
      //isEmailModalActive: false,
      //isImageAttachActive: false,
      docAttachActive: false,
      selectedDocuments: [],
      emailer: {
        id: null,
        reportName: null,
        assetId: ''
      },
      //reportBytes: null,
      // reportContentType: '',
      selectedImages: [],
      quoteIds: [],
      isEnteringNewEmail: false,
      selectedImageIds: [],
      // replyToMessageId: '',
      replyToSenderEmails: [],
      replyToEmailCcs: [],
      replyToEmailBccs: [],
      isAttachmentModalActive: false,
      innerReplyToEmail: {},
      innerReplyToEmailSubject: '',
      innerReplyToEmailMessage: '',
      innerSelectedAttachmentEmailId: '',
      editMaximize: true,

      isEmailTemplateModalActive: false,
      isTemplateLoading: false,
      templates: [],
      messages: [],
      selectedTemplate: '',
      templateFilter: {
        message: '',
        pageIndex: 1,
        pageSize: 999
      },
      innerMsgDetails: {},
      defaultCc: '',
      showAttachDropdown: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'company/company'
    }),
    companyEnabledAutoCC() {
      return this.company.setting ? this.company.setting.enabledAutoCC : false
    },
    getSender() {
      const message = this.innerReplyToEmail
      const isEmpty = this.isEmptyObject(message)
      return isEmpty ? '' : message.isIncoming ? message.sender : message.recipients
    },
    // reportExtension() {
    //   return mimeTypes.extension(this.reportContentType)
    // }
    isAllowAutoCC() {
      return this.companyEnabledAutoCC && this.defaultCc && !this.replyToEmailCcs.includes(this.defaultCc)
    }
  },
  watch: {
    replyToEmail(message) {
      this.resetEmailer()
      this.clearSelectedTemplate()
      this.innerReplyToEmail = _cloneDeep(message || {})
      this.buildReplyEmail()
      //this.resetEmailer()
      //this.clearSelectedTemplate()
    },
    // replyToMessage(value) {
    //   this.replyToMessageId = value
    // },
    // replyToSender(value) {
    //   this.replyToSenderEmails = value ? [value] : []
    // },
    emailer: {
      handler: function (newVal, oldVal) {
        // Emit email data change for preview update
        this.$emit('emailDataChanged', newVal)
      },
      deep: true
    },
    'emailer.attachments': {
      handler: function (newVal, oldVal) {
        if (this.selectedImages && this.selectedImages.length) {
          const differences = this.selectedImages.filter(function (image) {
            const index = newVal.findIndex((i) => i === image.fileName)
            return index === -1
          })
          if (!_isEmpty(differences)) {
            differences.forEach((diff) => {
              const imageIndex = this.selectedImages.findIndex((i) => i.fileName === diff.fileName)
              if (imageIndex !== -1) this.selectedImages.splice(imageIndex, 1)
              const idIndex = this.selectedImageIds.findIndex((id) => id === diff.quoteImageId)
              if (idIndex !== -1) this.selectedImageIds.splice(idIndex, 1)
            })
          }
        }
        // if (this.selectedImages.length > 0) {
        //   const difference = this.selectedImages.filter(function(image) {
        //     const index = newVal.findIndex(i => i === image.fileName)
        //     return index === -1
        //   })
        //   if (!_isEmpty(difference)) {
        //     const imageIndex = this.selectedImages.findIndex(i => i.fileName === difference[0].fileName)
        //     this.selectedImages.splice(imageIndex, 1)
        //     const idIndex = this.selectedImageIds.findIndex(id => id === difference[0].quoteImageId)
        //     this.selectedImageIds.splice(idIndex, 1, Guid.empty())
        //   }
        // }
      },
      deep: true
    },
    selectedAttachmentEmailId: {
      handler: function (newVal, oldVal) {
        this.innerSelectedAttachmentEmailId = newVal
        this.isAttachmentModalActive = !!newVal
      }
    }
  },

  async created() {
    this.clearSessionStorage()
    this.checkCompanySetting()
    this.setEmailer()
    await this.fetchDefaultCc()
    this.getEmailMessageDropdown()
    this.assignInnerValue()
  },
  mounted() {
    this.resetEmailer()
    this.buildReplyEmail()
    if (this.isAllowAutoCC) {
      this.replyToEmailCcs.push(this.defaultCc)
    }
  },
  beforeDestroy() {
    this.cleanEmailer()
  },
  methods: {
    async checkCompanySetting() {
      if (!this.company.setting) {
        await this.$store.dispatch('company/getCompanySetting')
      }
    },
    async fetchDefaultCc() {
      this.defaultCc = this.isAllowAutoCC ? this.$userInfo.email || '' : ''
    },
    toggleAttachDropdown() {
      this.showAttachDropdown = !this.showAttachDropdown
    },
    assignInnerValue() {
      this.innerMsgDetails = this.msgDetails
    },
    isEmptyObject(obj) {
      // Check if obj is an object and not null
      if (typeof obj === 'object' && obj !== null) {
        // Get the internal [[Class]] property
        var objClass = Object.prototype.toString.call(obj)

        // Check if the object is an object literal or an instance of Object
        if (objClass === '[object Object]' || objClass === '[object ObjectConstructor]') {
          // Check if the object has no own enumerable properties
          return Object.keys(obj).length === 0
        }
      }

      // Return false for non-object types or non-empty objects
      return false
    },
    buildReplyEmail() {
      const isEmpty = this.isEmptyObject(this.innerReplyToEmail)
      if (!isEmpty && this.innerReplyToEmail.messageId) {
        const sender = this.getSender
        this.replyToSenderEmails = sender ? [sender] : []

        const cc = this.innerReplyToEmail.cc
        this.replyToEmailCcs = cc ? cc.split(',') : []

        // Always add defaultCc from server to CC if not present
        if (this.isAllowAutoCC) {
          this.replyToEmailCcs.push(this.defaultCc)
        }

        const bcc = this.innerReplyToEmail.bcc
        this.replyToEmailBccs = bcc ? bcc.split(',') : []

        const replyCurrentDate = new Date()
        if (this.innerReplyToEmail.subject) {
          this.innerReplyToEmailSubject = 'Re: ' + this.innerReplyToEmail.subject
          this.emailer.subject = this.innerReplyToEmailSubject
        }

        this.innerReplyToEmailMessage = this.emailer.message + '\n\n\n\n'
        this.innerReplyToEmailMessage += `On ${replyCurrentDate}, ${this.getSender} wrote:\n\n`
        this.innerReplyToEmailMessage += this.innerReplyToEmail.message
        // if (this.getSender)
        //   this.innerReplyToEmailMessage = `${this.emailer.message} \n\n\n\nOn ${currentDate}, ${this.getSender} wrote:\n\n` + this.innerReplyToEmail.message
      } else {
        // this.resetEmailer()
        this.innerReplyToEmailSubject = this.emailer.subject
        this.innerReplyToEmailMessage = this.emailer.message
        this.replyToSenderEmails = []
        this.replyToEmailCcs = this.defaultCc ? [this.defaultCc] : []
        this.replyToEmailBccs = []
      }
      //return message
    },
    newEmailInput(newEmail) {
      this.isEnteringNewEmail = newEmail
    },
    clearSessionStorage() {
      sessionStorage.removeItem(`${this.$userInfo.sessionId}|${this.$route.meta.ekey}`)
      sessionStorage.removeItem(`${this.$userInfo.sessionId}|${this.$route.meta.pkey}`)
    },
    setEmailer() {
      let emailer = new Emailer()
      emailer.assetId = this.quote.quoteId
      emailer.assetType = EmailAssetTypes.Quote
      emailer.assetTypes = [AssetTypes.Customer, AssetTypes.Insurer]
      emailer.remark = `Quote ${this.quote.prefix}${this.quote.quoteNo}${this.quote.suffix}`
      if (this.companyEnabledAutoCC && this.$userInfo.email) {
        emailer.ccEmails = [this.$userInfo.email]
      }
      emailer.remarkTypeId = RemarkTypes.OtherSystemRemark
      emailer.subject = `Quote No: ${this.quote.quoteNo || 'NA'} - Claim No: ${this.quote.claimNo || 'NA'} - Rego: ${this.quote.vehicleRego || 'NA'} `
      emailer.reportName = `${this.quote.prefix}${this.quote.quoteNo}${this.quote.suffix}`
      this.addEmailer(emailer)
      this.emailer = _cloneDeep(this.getEmailer(emailer.id))
    },
    async resetEmailer() {
      //console.log('reset Emailer')
      let _emailer = null
      if (!_emailer) _emailer = this.retrieveEmailer()
      if (!_emailer) _emailer = StoreUtil.getLocalStorage(this.emailer.id, 'emailer')
      if (!_emailer) _emailer = _cloneDeep(this.getEmailer(this.emailer.id) || new Emailer())
      _emailer.message = `\n\n${divider}\n${copyright.replace(/\[COMPANY\]/g, this.$userInfo.companyName)}`
      this.emailer = _emailer
      this.persistEmailer()
      //this.updateAttachmentList()
    },
    retrieveEmailer() {
      return JSON.parse(sessionStorage.getItem(`${this.$userInfo.sessionId}|${this.$route.meta.ekey}`))
    },
    persistEmailer() {
      sessionStorage.setItem(`${this.$userInfo.sessionId}|${this.$route.meta.ekey}`, JSON.stringify(this.emailer))
    },
    cleanEmailer() {
      //console.log('cleanEmailer')
      StoreUtil.removeStorage(this.emailer.id, 'emailer')
      StoreUtil.removeLocalStorage(this.emailer.id, 'emailer')
      this.removeEmailer(this.emailer.id)
    },
    sent() {
      this.discardEmail()
      this.$emit('sent')
    },
    resetEmail() {
      this.discardEmail()
      this.$emit('resetEmail')
    },
    async send() {
      // this.isActive = false
      // this.$emit('update:active', false)
      await this.$refs.emailer.send()
      this.clearSelectedTemplate()
    },
    discardEmail() {
      //this.isImageAttachActive = false
      this.selectedImageIds.splice(0, this.selectedImageIds.length)
      this.selectedImages.splice(0, this.selectedImages.length)
      this.selectedDocuments.splice(0, this.selectedDocuments.length)
      // this.replyToMessageId = ''
      this.replyToSenderEmails = []
      this.replyToEmailCcs = []
      this.replyToEmailBccs = []
      this.resetEmailer()
    },
    toggleEditMaximize() {
      this.editMaximize = !this.editMaximize
      this.$emit('toggleEditMaximize')
    },
    async getEmailMessageDropdown() {
      this.isTemplateLoading = true
      const postData = { ...this.templateFilter, ...{ message: '' } }
      const templates = await EmailService.getEmailTemplateDropdown(postData)
      this.templates = templates
      if (this.templateFilter.message !== '') {
        this.selectedTemplate = this.templates.find((c) => c.message === this.templateFilter.message)
        if (!this.selectedTemplate) {
          this.clearSelectedTemplate()
          const templates = await EmailService.getEmailTemplateDropdown(this.templateFilter)
          this.templates = templates
        }
      }
      this.isTemplateLoading = false
    },
    async closeTemplateModal() {
      this.isEmailTemplateModalActive = false
      //console.log('close template modal')
      setTimeout(async () => await this.getEmailMessageDropdown(), 1000)
    },
    selectTemplate(selected) {
      //this.innerMsgDetails.customer = this.extractName(this.getSender)
      this.resetEmailer()
      this.clearSelectedTemplate()
      this.buildReplyEmail()
      this.templateFilter.message = selected.message
      this.selectedTemplate = selected
      //console.log(this.emailer.message)
      const templateMessage = this.replaceTags(selected.message)
      this.innerReplyToEmailMessage = templateMessage + '\n\n' + this.innerReplyToEmailMessage
    },
    clearSelectedTemplate() {
      this.templateFilter.message = ''
      //this.innerReplyToEmail.message = ''
      //this.innerMsgDetails.customer = this.msgDetails.customer
      this.selectedTemplate = ''
    },
    replaceTags(message) {
      message = message.replace(/\[QUOTEID\]/g, this.innerMsgDetails.quoteId)
      message = message.replace(/\[NAME\]/g, this.innerMsgDetails.customer)
      message = message.replace(/\[REGO\]/g, this.innerMsgDetails.rego)
      message = message.replace(/\[EST START DATE\]/g, this.innerMsgDetails.jobStart)
      message = message.replace(/\[EST END DATE\]/g, this.innerMsgDetails.jobEnd)
      message = message.replace(/\[EXCESS\]/g, this.innerMsgDetails.excess)
      message = message.replace(/\[SHOPNAME\]/g, this.innerMsgDetails.shopName)
      return message
    },
    extractName(sender) {
      if (sender) {
        let matchName = sender.match(/^[^<]*/)
        if (matchName) return matchName[0].trim()
        let matchEmail = sender.match(/<([^>]+)>/)
        if (matchEmail) return matchEmail[1]
      }
      return ''
    },
    resetReplyToEmail() {
      this.innerReplyToEmail = {}
      this.innerReplyToEmailSubject = ''
      this.innerReplyToEmailMessage = ''
      // this.replyToMessageId = ''
      this.replyToSenderEmails = []
      this.replyToEmailCcs = []
      this.replyToEmailBccs = []
    },
    closeAttachModal() {
      this.isAttachmentModalActive = false
      this.innerSelectedAttachmentEmailId = ''
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-group {
  justify-content: flex-end;
}

.buttons-group > .button:not(:last-child) {
  margin-right: 0.5em;
}
</style>
